console.log(process.APPENV)

export const WechatOAuth = ({ redirect, state, scope }) => {
  if (!redirect) {
    return '/'
  }
  console.log(redirect)
  redirect = encodeURIComponent(redirect)
  // scope = 'snsapi_userinfo'
  location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.APPENV.WechatAppId}&redirect_uri=${redirect}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
}

const sysConstConfig = Object.assign({}, process.APPENV, {
  // 打包环境
  env: process.env.NODE_ENV,
  webPath: `${process.APPENV.base}/${process.APPENV.route}`
})

if (process.env.NODE_ENV === 'development') {
  sysConstConfig.api = 'http://192.168.3.7:8888'
  // sysConstConfig.api = 'https://www.jszauto.com/wx'
  // sysConstConfig.api = 'http://192.168.3.12:8888'
  // sysConstConfig.api = 'https://www.apeclassic.com/wx'
  // sysConstConfig.api = 'https://manage.uleemarkppf.com/wx'
  // sysConstConfig.api = 'https://www.apeclassic.com/qg1/'
  // sysConstConfig.api = 'http://116.62.170.83/wx'
  // sysConstConfig.api = 'http://manage.chinatangdu.com'
  // sysConstConfig.api = 'https://chiantu.apeclassic.com'
  // sysConstConfig.api = 'http://manage.chinatangdu.com/zzt'
  // sysConstConfig.api = 'https://manage.yfpmc.com/wx'
  // sysConstConfig.api = 'https://www.ffcamp.com/wx'
  // sysConstConfig.api = 'https://manage.juchuangzhonglian.com/wx'
  // sysConstConfig.api = 'https://bluefilms.apeclassic.com/wx'

  sysConstConfig.base = 'http://192.168.3.13:3030'
  // sysConstConfig.webPath = `http://192.168.3.13:3030/${process.APPENV.route}`
  sysConstConfig.webPath = ''
  sysConstConfig.assist = 'http://192.168.3.13:3030/assist/manage/outsourcing'
}

export default {
  ...sysConstConfig,
  themeConfig: process.APPTHEME
}